import {Options} from '@fl/cmsch-fe-library';
import {none, Opt} from 'ts-opt';

import {AnimalList} from 'api/gen/AnimalList';
import {AnimalType} from 'api/gen/AnimalType';
import {AnimalsBrowserFarm} from 'api/gen/AnimalsBrowserFarm';
import {AnimalsBrowserStable} from 'api/gen/AnimalsBrowserStable';
import {AvailableAnimal} from 'api/gen/AvailableAnimal';
import {EarTag} from 'api/gen/EarTag';
import {PagedModelBreedingFemale} from 'api/gen/PagedModelBreedingFemale';
import {PagedModelCabBreedingFemale} from 'api/gen/PagedModelCabBreedingFemale';
import {PagedModelCabCalf} from 'api/gen/PagedModelCabCalf';
import {PagedModelCalf} from 'api/gen/PagedModelCalf';
import {PagedModelStableToChoose} from 'api/gen/PagedModelStableToChoose';

import {BrowserLoadingId} from '../types/browser-loading-id';

/** State slice for the animal-browser screens, filters, exports, and saved-list workflows. */
export interface AnimalBrowserState {
    stablesPage: Opt<PagedModelStableToChoose>;
    cowBrowserPage: Opt<PagedModelBreedingFemale>;
    cabFemalePage: Opt<PagedModelCabBreedingFemale>;
    cabFemalesExistInSession: boolean;
    stableInfo: Opt<AnimalsBrowserStable>;
    farmInfo: Opt<AnimalsBrowserFarm>;
    calfBrowserPage: Opt<PagedModelCalf>;
    productionAreasInCentralEvidenceOptions: Opt<Options<string>>;
    printInProgress: boolean;
    exportInProgress: boolean;
    loading: Array<BrowserLoadingId>;
    cabCalfPage: Opt<PagedModelCabCalf>;
    cabCalvesExistInSession: boolean;
    organizationsPtOptions: Opt<Options<number>>;
    organizationsInsOptions: Opt<Options<number>>;
    districtCodesOptions: Opt<Options<number>>;
    breederOptions: Opt<Options<number>>;
    farmOptions: Opt<Options<number>>;
    stableOptions: Opt<Options<number>>;
    organizationsCenterInsOptions: Opt<Options<number>>;
    organizationsCenterPtOptions: Opt<Options<number>>;
    firstCabCalvesLoad: boolean;
    firstCabBreedingFemalesLoad: boolean;
    overviewListModalVisible: boolean;
    animalLists: Opt<Array<AnimalList>>;
    animalListsTag: Opt<AnimalType>;
    createAnimalListsFromIdsModalVisible: boolean;
    overwriteListFromIdsNameModalVisible: boolean;
    overwriteAnimalListFromIdsId: Opt<number>;
    selectedAnimalIds: Array<number>;
    addAnimalsModalVisible: boolean;
    availableAnimals: Opt<Array<AvailableAnimal>>;
    addAnimalsFromDBModalVisible: boolean;
    bullsForExport: Array<EarTag>;
    femalesForExport: Array<EarTag>;
}

/** Default animal-browser state snapshot. */
export const initialAnimalBrowserState: AnimalBrowserState = {
    stablesPage: none,
    cowBrowserPage: none,
    bullsForExport: [],
    femalesForExport: [],
    stableInfo: none,
    farmInfo: none,
    calfBrowserPage: none,
    cabFemalePage: none,
    cabFemalesExistInSession: false,
    productionAreasInCentralEvidenceOptions: none,
    printInProgress: false,
    exportInProgress: false,
    loading: [],
    cabCalfPage: none,
    cabCalvesExistInSession: false,
    organizationsPtOptions: none,
    organizationsInsOptions: none,
    districtCodesOptions: none,
    breederOptions: none,
    farmOptions: none,
    stableOptions: none,
    organizationsCenterInsOptions: none,
    organizationsCenterPtOptions: none,
    firstCabCalvesLoad: false,
    firstCabBreedingFemalesLoad: false,
    overviewListModalVisible: false,
    animalLists: none,
    animalListsTag: none,
    createAnimalListsFromIdsModalVisible: false,
    overwriteAnimalListFromIdsId: none,
    overwriteListFromIdsNameModalVisible: false,
    selectedAnimalIds: [],
    addAnimalsModalVisible: false,
    availableAnimals: none,
    addAnimalsFromDBModalVisible: false,
};
